<script>
    import PreviewElement from "./PreviewElement";
    import LeadFormWrapperElement from "../../components/pagesbuilder/elements/LeadFormWrapperElement";

    export default {
        name: "PreviewLeadFormWrapperElement",
        mixins: [
            PreviewElement,
            LeadFormWrapperElement
        ]
    }
</script>